import {
    SET_MODULE,
    SET_PANEL,
    SET_STATES,
    SET_TYPES,
    SET_ACTION_MAP,
    SET_CONFIG_MAP,
    SET_USER_FEATURE_MAP,
    SET_LOADING_MAP,
    SET_FILTERS_MAP,
    UPDATE_FILTER_ITEM_MAP,
} from './mutation-types';
import {isObject} from '@config/utils'

const mutations = {
    // [SET_MODULE](state, module) {
    //     let settings = module.settings;
    //     if(settings){
    //         let skeys = Object.keys(settings);
    //         let tools = state.data.tools;
    //         for (let pkey of Object.keys(tools)) {
    //             let tool = tools[pkey];
    //             let panel = tool.panel;
    //             let model = tool.model;
    //             if(model){
    //                 let skey = skeys.find( k => k==model);
    //                 if(skey){
    //                     let filteredSettings = Object.keys(settings[skey]).filter((k) => {
    //                         return Object.keys(panel).includes(k);
    //                     });
    //                     for (let fkey of filteredSettings) {
    //                         Object.assign(panel[fkey], settings[skey][fkey]);
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     delete module.settings;
    //     state.data.module = module;
    // },
    [SET_PANEL](state, {id, ...params}) {
        let panel = null;
        let tools = state.data.tools;
        if(tools[id]){
            panel = tools[id].panel;
        }
        if(!panel){
            return;
        }
        for (var key in params) {
            if(['active', 'show', 'loaded', 'collapsed'].includes(key)){
                params[key] = !!params[key];
            }
            if (panel.hasOwnProperty(key) && params[key] !== undefined) {
                if(isObject(panel[key]) && isObject(params[key])){
                    panel[key] = {...panel[key], ...params[key]};
                }else{
                    panel[key] = params[key];
                }
            }
        }
    },
    [SET_STATES](state, states) {
        state.data.states = states;
    },
    [SET_TYPES](state, types) {
        state.data.types = types;
    },
    [SET_ACTION_MAP](state, action) {
        state.data.map.action = action;
    },
    [SET_CONFIG_MAP](state, config) {
        state.data.map.config = Object.assign(state.data.map.config, config);
    },
    [SET_USER_FEATURE_MAP](state, feature) {
        state.data.map.user_feature = feature;
    },
    [SET_LOADING_MAP](state, flag) {
        state.data.map.loading = flag;
    },
    [SET_FILTERS_MAP](state, filters) {
        state.data.map.filters = filters;
    },
    [UPDATE_FILTER_ITEM_MAP](state, {tp, id, show, qty, item=null}) {
        if(!item){
            item = state.data.map.filters[tp].find(item => item.id == parseInt(id));
        }
        if(show !== undefined){
            item.show = show;
        }
        if(qty !== undefined){
            item.qty = qty;
        }
    },
};

export default mutations;
